import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { formatMoney } from '../../utils/formatMoney.utils.js';
import { formatNumber } from '../../utils/formatNumber.utils.js';
import css_248z from './stockPerformance.styles.css.js';
import '../Text/text.js';
import '../Icons/upVectorIcon.js';
import '../Icons/downVectorIcon.js';
import '../Icons/upIcon.js';
import '../Icons/downIcon.js';

let StockPerformance = class StockPerformance extends LitElement {
    constructor() {
        super(...arguments);
        this.performancePercentage = 0;
        this.performanceAmount = { amount: 0, currency: '' };
        this.type = '';
        this.plusSymbol = false;
        this.noWrap = false;
        this.preset = 'paragraph1';
    }
    get icon() {
        return this.performanceAmount.amount >= 0
            ? html `<up-vector-icon
          size="16"
          class="wrapper__stock__performance__icon icon--smaller"
          color="positive"
        ></up-vector-icon>`
            : html `<down-vector-icon
          size="16"
          class="wrapper__stock__performance__icon icon--smaller"
          color="negative"
        ></down-vector-icon>`;
    }
    get bigIcon() {
        return this.performanceAmount.amount >= 0
            ? html `<up-icon size="24" color="positive"></up-icon>`
            : html `<down-icon size="24" color="negative"></down-icon>`;
    }
    get performanceStyle() {
        return this.performanceAmount.amount >= 0 ? 'positive' : 'negative';
    }
    get plusSymbolText() {
        return this.performanceAmount.amount >= 0 && this.plusSymbol ? '+' : '';
    }
    get performanceAmountText() {
        return `${this.plusSymbolText}${formatMoney(this.performanceAmount.amount, this.performanceAmount.currency)}`;
    }
    get performanceSummary() {
        return `${formatNumber(this.performancePercentage)}%`;
    }
    renderSwitch(type) {
        switch (type) {
            case 'icon':
                return html `<div class="wrapper__stock__bigIcon">${this.bigIcon}</div>`;
            case 'amount':
                return html `<div class="wrapper__stock__performance">
          ${this.performanceAmountText}
        </div>`;
            case 'percentage':
                return html `
          <div class="wrapper__stock__performance">
            <span class="wrapper__stock__performance"
              >${this.performanceSummary}</span
            >
            <span class="wrapper__stock__amount"
              >(${this.performanceAmountText})</span
            >
          </div>
        `;
            case 'summary':
                return html `
          <div class="wrapper__stock ${this.noWrap ? 'nowrap' : ''}">
            <span class="wrapper__stock__performance">
              ${this.icon}
              <ht-text
                preset=${this.preset}
                color=${this.performanceStyle}
                text=${this.performanceSummary}
              ></ht-text>
            </span>
          </div>
        `;
            default:
                return html `
          <div class="wrapper__stock ${this.noWrap ? 'nowrap' : ''}">
            <span class="wrapper__stock__amount">
              <ht-text
                preset=${this.preset}
                color=${this.performanceStyle}
                text=${this.performanceAmountText}
              ></ht-text>
            </span>
            <span class="wrapper__stock__performance">
              ${this.icon}
              <ht-text
                preset=${this.preset}
                color=${this.performanceStyle}
                text=${this.performanceSummary}
              ></ht-text>
            </span>
          </div>
        `;
        }
    }
    render() {
        return html `
      <div class="performance ${this.performanceStyle}">
        ${this.renderSwitch(this.type)}
      </div>
    `;
    }
};
StockPerformance.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: Number, attribute: 'performance-percentage' })
], StockPerformance.prototype, "performancePercentage", void 0);
__decorate([
    property({ type: Object, attribute: 'performance-amount' })
], StockPerformance.prototype, "performanceAmount", void 0);
__decorate([
    property({ type: String })
], StockPerformance.prototype, "type", void 0);
__decorate([
    property({ type: Boolean, attribute: 'plus-symbol' })
], StockPerformance.prototype, "plusSymbol", void 0);
__decorate([
    property({ type: Boolean, attribute: 'no-wrap' })
], StockPerformance.prototype, "noWrap", void 0);
__decorate([
    property({ type: String })
], StockPerformance.prototype, "preset", void 0);
StockPerformance = __decorate([
    customElement('stock-performance')
], StockPerformance);
var StockPerformance$1 = StockPerformance;

export { StockPerformance$1 as default };
//# sourceMappingURL=stockPerformance.js.map
